export interface Relationship {
  id: number;
  relationship_name: string;
  relationship_code: string;
  description?: string;
  gender_applicable: string;
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
}

export type RelationshipPayload = Pick<
  Relationship,
  | "relationship_name"
  | "relationship_code"
  | "description"
  | "gender_applicable"
  | "is_active"
>;

export const RELATIONSHIP_PRESETS = [
  { name: "Father", code: "FTH" },
  { name: "Mother", code: "MTH" },
  { name: "Husband", code: "HUS" },
  { name: "Wife", code: "WIF" },
  { name: "Son", code: "SON" },
  { name: "Daughter", code: "DTR" },
  { name: "Brother", code: "BRO" },
  { name: "Sister", code: "SIS" },
  { name: "Grandfather", code: "GFA" },
  { name: "Grandmother", code: "GMO" },
  { name: "Uncle", code: "UNC" },
  { name: "Aunt", code: "AUN" },
  { name: "Guardian", code: "GUA" },
  { name: "Spouse", code: "SPO" },
  { name: "Other", code: "OTH" },
] as const;

export const RELATIONSHIP_NAME_OPTIONS = RELATIONSHIP_PRESETS.map(r => ({
  value: r.name,
  label: r.name,
}));

export const RELATIONSHIP_NAME_TO_CODE = Object.fromEntries(
  RELATIONSHIP_PRESETS.map(r => [r.name, r.code])
);
